var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-box" },
    [
      _c(
        "el-dialog",
        _vm._g(
          _vm._b(
            {
              attrs: {
                visible: _vm.visible,
                title: _vm.text,
                width: "80%",
                center: "",
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
                closed: _vm.resetAllData,
              },
            },
            "el-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "details" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-collapse",
                  {
                    model: {
                      value: _vm.activeNames,
                      callback: function ($$v) {
                        _vm.activeNames = $$v
                      },
                      expression: "activeNames",
                    },
                  },
                  [
                    _c(
                      "el-collapse-item",
                      { attrs: { name: "1" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "collapse-title",
                            attrs: { slot: "title" },
                            slot: "title",
                          },
                          [_vm._v("基本信息")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-container",
                          { staticClass: "basis" },
                          [
                            _c("el-aside", { attrs: { width: "200px" } }, [
                              _c(
                                "div",
                                { staticClass: "image" },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: _vm._f("picFilter")(
                                        _vm.params.materialImage,
                                        { size: "large" }
                                      ),
                                      "preview-src-list": [
                                        _vm.params.materialImage,
                                      ],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-main", [
                              _vm.type === "1"
                                ? _c("div", [
                                    _c("div", { staticClass: "pb-10" }, [
                                      _vm._v(
                                        "物料名称：" +
                                          _vm._s(_vm.params.materialName)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pb-10" }, [
                                      _vm._v(
                                        "供应商编号/色号：" +
                                          _vm._s(_vm.params.supplierSpu) +
                                          "/" +
                                          _vm._s(_vm.params.supplierColor)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pb-10" }, [
                                      _vm._v(
                                        "订单编号：" +
                                          _vm._s(_vm.params.orderCode)
                                      ),
                                    ]),
                                  ])
                                : _c("div", [
                                    _c("div", { staticClass: "pb-10" }, [
                                      _vm._v(
                                        "二次工艺名称：" +
                                          _vm._s(
                                            _vm.params.secondaryProcessName
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pb-10" }, [
                                      _vm._v(
                                        "物料项目/编码：" +
                                          _vm._s(
                                            _vm.params.temporaryFabricCoding
                                          ) +
                                          "/" +
                                          _vm._s(_vm.params.materialCode)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pb-10" }, [
                                      _vm._v(
                                        "订单编号：" +
                                          _vm._s(_vm.params.orderCode)
                                      ),
                                    ]),
                                  ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-collapse-item", { attrs: { name: "2" } }, [
                      _vm.type === "1"
                        ? _c(
                            "span",
                            {
                              staticClass: "collapse-title",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [_vm._v("采购信息")]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "collapse-title",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [_vm._v("加工信息")]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pur-info pt-16" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _vm.type === "1"
                                    ? _c(
                                        "div",
                                        { staticClass: "d-inline-block mr-4" },
                                        [
                                          _vm._v(
                                            "采购" +
                                              _vm._s(_vm.unitName) +
                                              "数:"
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "d-inline-block mr-4" },
                                        [
                                          _vm._v(
                                            "加工" +
                                              _vm._s(_vm.unitName) +
                                              "数:"
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.purInfo.purchaseQty)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _vm.type === "1"
                                    ? _c(
                                        "div",
                                        { staticClass: "d-inline-block mr-4" },
                                        [
                                          _vm._v(
                                            "预估" +
                                              _vm._s(_vm.unitName) +
                                              "数:"
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "d-inline-block mr-4" },
                                        [
                                          _vm._v(
                                            "预估" +
                                              _vm._s(_vm.unitName) +
                                              "数:"
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.purInfo.estimateQty)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-block mr-4" },
                                    [
                                      _vm._v(
                                        "订单" + _vm._s(_vm.unitName) + "数:"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.purInfo.orderQty)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-block mr-4" },
                                    [
                                      _vm._v(
                                        "差异" + _vm._s(_vm.unitName) + "数:"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.purInfo.differenceQty)),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-collapse-item", { attrs: { name: "3" } }, [
                      _c(
                        "span",
                        {
                          staticClass: "collapse-title",
                          attrs: { slot: "title" },
                          slot: "title",
                        },
                        [_vm._v("档口信息")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "stall-info pt-16 " },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-block mr-4" },
                                    [_vm._v("实际档口名称：")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.materialPurchaseOrderDetail
                                          .suggestSupplierName
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-block mr-4" },
                                    [_vm._v("档口联系电话：")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.materialPurchaseOrderDetail
                                          .suggestSupplierTel
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-inline-block mr-4" },
                                      [_vm._v("变更档口原因：")]
                                    ),
                                    _vm._v(" "),
                                    _c("OpSelect", {
                                      attrs: {
                                        api: "/pdm/commonDictionary/queryByGroupIdentification/mesChangeStallReason",
                                        "selected-value":
                                          _vm.materialPurchaseOrderDetail
                                            .changeSupplierReason,
                                        "is-readonly": true,
                                      },
                                      model: {
                                        value:
                                          _vm.materialPurchaseOrderDetail
                                            .changeSupplierReason,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.materialPurchaseOrderDetail,
                                            "changeSupplierReason",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "materialPurchaseOrderDetail.changeSupplierReason",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              ref: "uploadParams",
                              staticClass: "demo-form-inline",
                              attrs: { inline: true },
                            },
                            [
                              _c("el-form-item", { attrs: { label: "" } }, [
                                _c("div", { staticClass: "upload-title" }, [
                                  _c("span", [_vm._v("凭证信息:")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  _vm._l(
                                    _vm.fileListData,
                                    function (item, index) {
                                      return _c("el-image", {
                                        key: index,
                                        staticClass: "image",
                                        attrs: {
                                          src: _vm._f("picFilter")(item.url, {
                                            size: "large",
                                          }),
                                          "preview-src-list": [item.url],
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "main-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.resetAllData } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-link",
          on: {
            click: function ($event) {
              return _vm.getCredentialInfo(_vm.rowData["id"])
            },
          },
        },
        [_vm._v(_vm._s(_vm.text))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }